import create from './create';
import edit from './edit';
import list from './list';

const ApiCall = {
  list,
  create,
  edit,
};

export default ApiCall;
